const cardProduct = function cardProduct(data) {
  let cardClass;
  let arrCardImage = [];
  let cardImg;

  for (i=0; i<data.length; i++){
    row = data[i];
    cardImg = "";

    if (row.image) {
      cardImg= '<img src="'+row.image+'" alt="'+row.seller_name+'" width="" height="" class="card__artist__img">';
    }
    $('[data-vendor_image="' + row.seller_name + '"]').html(cardImg);
  }
}

// card__artist__imgの個数取得
function getCardProductVendor() {
  let param;
/*
  if ($('[data-vendor]').length > 0) {
    let arrVendor = [];
    let vendor;
    for (let i=0; i<$('[data-vendor]').length; i++) {
      vendor = "arr_seller_name[]="+$('[data-vendor]').eq(i).attr('data-vendor');
      if($.inArray(vendor, arrVendor) == -1) {
        arrVendor.push(vendor);
      }
    }

    // get用のパラメータ作成
    param = "?"+arrVendor.join("&");
  }
*/
  param = '';
  return param;
}

const doCardProductVendor = function(){
  let param = getCardProductVendor();
  fetchBase(mallDomain + "/api/shop"+param, cardProduct);
}

setTimeout(function(){
  doCardProductVendor();
}, 800)

$(document).on('change', '#SortBy', function(){
  setTimeout(function(){
    doCardProductVendor();
  }, 800);
});